import {
  IBaseModule,
  IMessage,
} from "@/store/common/Types";
import ApiService from "@/core/services/ApiService";
import { Actions, Mutations, Endpoints } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

@Module
export default class CrmModule extends VuexModule implements IBaseModule {
  errors = {};

  /**
   * Get crm errors
   * @returns array
   */
  get getCrmErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Action
  [Actions.CRM_SYNC]() {
    ApiService.setHeader();
    return ApiService.post(Endpoints.Crm + "/sync", {})
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        const error = "There was an error writing to the queue.";
        if (!response) {
          this.context.commit(Mutations.SET_ERROR, [error]);
        }
        else if (response.data && response.data.errors) {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
        }
        else if(response.status == 429){
          this.context.commit(Mutations.SET_ERROR, ["429"]);
        }
        else{
          this.context.commit(Mutations.SET_ERROR, [error]);
        }
      });
  }
}
